import React from "react";
import { Redirect } from "react-router-dom";
import UserStore from "../stores/UserStore";
import GoogleButton from "react-google-button";
import { Button } from "@material-ui/core";
import { TextField, Grid, AppBar, Toolbar, Typography, IconButton, Paper, Link } from "@material-ui/core/";
import { Menu } from "@material-ui/icons";
import styles from "./LayoutStyle";
import { withStyles } from "@material-ui/core/styles";
import classNames from "classnames";
import Footer from './Footer'
import MessageAction from './MessageAction';
import ClientCaptcha from "react-client-captcha";
import { alert } from "../img";

class Login extends React.Component {
  state = {
    error: false,
    email: "",
    password: "",
    captured: "",
    captcha: ""
  };

  constructor(props) {
    super(props);
    this.redirects = 0;
    if (!UserStore.isAuth()) {
      if (UserStore.popLocal("logout") !== "true") {
        if (props.location.pathname !== "/login")
          UserStore.saveLocal("from", JSON.stringify(props.location));
      } else UserStore.popLocal("from");
    }
  }

  from = () => {
    return UserStore.getLocal("from") !== null
      ? JSON.parse(UserStore.getLocal("from"))
      : { pathname: "/" };
  };

  async componentDidMount() {
    document.title = "GO | Iniciar sesión";

    if (!UserStore.isAuth()) {
      try {
        await UserStore.initLoginUser(window.location.search);
        this.setState({ error: false });
      } catch (e) {
        this.props.history.replace(window.location.pathname);
        this.setState({ error: e });
      }
    }
  }

  loginGoogle = () => {
    UserStore.authenticateGoogle();
  };

  submitDisabled = () => {
    // const { password, email, captured } = this.state;
    // return password === "" || email === "" || captured === "";
    const { password, email } = this.state;
    return password === "" || email === "";
  };

  onSubmit = e => {
    const { password, email } = this.state;
    UserStore.sign_in({ password, email }, e => {
      if((typeof(e.response.data.exception) === 'string') && ((e.response.data.exception.includes('registered')) || (e.response.data.exception.includes('found')))){
         this.setState({
           error: 'Datos incompletos favor de contactar al departamento de Recursos Humanos'
         });
      }
      else{
         this.setState({ error: e.response.data.error });
      }
    });
    e.preventDefault();
    // const { password, email, captcha, captured } = this.state;
    //
    // e.preventDefault();
    //
    // if(captcha !== captured){
    //   this.setState({ error: 'El código es incorrecto, intente de nuevo' })
    // }
    // else{
    //   this.setState({ captcha: "", captured: "", error: false })
    //   UserStore.sign_in({ password, email }, e => {
    //
    //     if((typeof(e.response.data.exception) === 'string') && ((e.response.data.exception.includes('registered')) || (e.response.data.exception.includes('found')))){
    //        this.setState({
    //          error: 'Datos incompletos favor de contactar al departamento de Recursos Humanos'
    //        });
    //     }
    //     else{
    //        this.setState({ error: e.response.data.error });
    //     }
    //   });
    //
    // }


  };

  onChangeEmail = e => {
    this.setState({ email: e.target.value });
  };

  onChangePassword = e => {
    this.setState({ password: e.target.value });
  };

  // onChangeCaptcha = e => {
  //   this.setState({ captured: e.target.value });
  // };

  setCode = captcha => {
    // this.setState({ captcha })
  }

  render() {
    if (
      UserStore.isAuth() &&
      this.state.error === false &&
      this.redirects === 0
    ) {
      this.redirects += 1;
      return <Redirect to={this.from()} />;
    }
    const islogin = this.props.location.pathname === '/login'
    const { classes } = this.props;
    const { error, captured, captcha } = this.state;
    const LoginArea = (
      <LoginRender
        loginGoogle = {this.loginGoogle}
        disabled = {this.submitDisabled()}
        changePassword = {this.onChangePassword}
        changeEmail = {this.onChangeEmail}
        onSubmit = {this.onSubmit}
        error = {error}
        changeCaptcha = {this.onChangeCaptcha}
        captured = {captured}
        setCode = {this.setCode}
        captcha = {captcha}
      />
    );

    let container = LoginArea;

    if(islogin){
    const LoginContainer = (
      <div>
      <AppBar
        position="absolute"
        className={classNames(classes.appBar, classes.appBarShift)}
      >
        <Toolbar disableGutters={true}>
          <Grid
            container
            spacing={0}
            justify={"space-between"}
            direction={"row"}
            alignItems={"center"}
          >
            <Grid item sm={5} md={3} lg={3}>
              <IconButton
                style={{ float: "left" }}
                color="inherit"
                aria-label="open drawer"
                className={classes.menuButton}
              >
                <Menu data-tut="toolbar"/>
              </IconButton>
              <Typography
                variant="h6"
                color="inherit"
                noWrap
                className="title"
              >
                Iniciar sesión
              </Typography>
            </Grid>
            <Grid item xs={1} sm={5} md={5} lg={6}>
            </Grid>
            <Grid item sm={2} md={3} lg={3}>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
      <Grid container style={{marginTop: 64}}>
        <Grid item lg={4} xl={4} md={3} sm={false} xs={false} />
        <Grid item lg={4} xl={4} md={5} sm={12} xs={12}>
          <br/>
           <Paper className={classes.rootPaper}>
            {LoginArea}
          </Paper>
          <br />
        </Grid>
        <Grid item lg={4} xl={4} md={3} sm={false} xs={false} />
      </Grid>
      </div>
    );
    container = LoginContainer;
  }
    return (
      <div className="login_screen">
        {container}
        <Footer />
      </div>
    );
  }
}

const LoginRender = props =>{
  const { loginGoogle, disabled, changeEmail, changePassword, onSubmit, error, changeCaptcha, setCode } = props;

  let ad = null;

  //message
  if(process.env.REACT_APP_DISABLED2FA === 'true'){
    ad = (
      <Grid item xs={12} sm={12} md={12} lg={12}  xl={12}>
        <Grid container justify="center">
          <Grid item>
            <img src={alert} alt="alert" width="60px"/>
          </Grid>
          <Grid item>
            <Typography variant="body1" className="message_staging">
              Esta página es exclusiva para desarrolladores.
            </Typography>
            <Typography variant="body1" className="message_staging">
              Para acceder al gestor de oficios (GO) ir a:
            </Typography>
            <Typography variant="body1" className="message_staging">
              <Link href="https://go.uach.mx">https://go.uach.mx</Link>
            </Typography>
          </Grid>
        </Grid>
        <br/>
      </Grid>
    );
  }

  return(
    <Grid container justify="center">
      {ad}
    <img
      src="images/logo/login.png"
      alt="Gestor de Oficios digitales"
      width="243px"
      height="220px"
    />
    <form style={{ width: "100%" }} onSubmit={onSubmit}>
      <br />
      <Grid>
        <TextField
          label="Usuario"
          fullWidth
          onChange={changeEmail}
        />
      </Grid>
      <Grid>
        <br />
        <TextField
          label="Contraseña"
          type="password"
          fullWidth
          onChange={changePassword}
        />
      </Grid>
      {/* <Grid>
        <br />
        <TextField
          label="Código"
          type="text"
          fullWidth
          onChange={changeCaptcha}
        />
        <br />
        <br />
        <ClientCaptcha
          captchaCode={setCode}
          charsCount={6}
          backgroundColor="#694a8a"
          fontColor="#FFFFFF"
          width={150}/>
      </Grid> */}
      <Grid item sm={12}>
        <Grid item lg={12} xl={12} md={12} sm={12} xs={12}>
          <MessageAction type="error" message={error} show={error !== false? true : false}/>
        </Grid>
        <br />
        <br />
        <Grid container justify="center">
          <Button
            color="primary"
            variant="contained"
            type="submit"
            disabled={disabled}
          >
            Iniciar sesión
          </Button>
        </Grid>
        <br />
      </Grid>
    </form>
    <Grid item style={{textAlign:'center'}} lg={12} xl={12} md={12} sm={12} xs={12}>
        O
    </Grid>
    <Grid item sm={12}>
      <br />
      <Grid container justify="center">
        <GoogleButton
          label="Iniciar sesión con Google"
          onClick={loginGoogle}
        />
      </Grid>
      <br/>
    </Grid>
  </Grid>
  )
}

export default withStyles(styles)(Login);



// WEBPACK FOOTER //
// ./src/components/Login.js